import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/components-library';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { ModalSize } from 'components/modal';

import { ConfirmRestaurantMap } from './confirm-restaurant-map';
import {
  Address,
  ButtonContainer,
  Details,
  InfoWrapper,
  MapContainer,
  P,
  StyledModal,
  Title,
} from './modal-confirm-restaurant.styled';
import { IModalConfirmRestaurantViewProps } from './types';

export const ModalConfirmRestaurantView: FC<IModalConfirmRestaurantViewProps> = ({
  address,
  changeText,
  city,
  confirmText,
  distanceText,
  handleChangeRestaurant,
  handleConfirmRestaurant,
  lat,
  lng,
  stateProvince,
  yourClosestStore,
}) => (
  <StyledModal
    size={ModalSize.SMALL}
    allowsDismiss={false}
    onDismiss={() => handleConfirmRestaurant(false)}
    mParticleEventData={{
      modalAppearanceEventMessage: 'Confirm auto-selected restaurant modal',
    }}
    data-testid="modal-confirm-restaurant-mobile"
  >
    <InfoWrapper>
      <MapContainer>
        <ConfirmRestaurantMap lat={lat} lng={lng} />
      </MapContainer>
      <Details>
        <Title id="modal-heading">{yourClosestStore}</Title>
        <Address>{address}</Address>
        <P>
          {city}, {stateProvince}
        </P>
        <P>{distanceText}</P>
      </Details>
    </InfoWrapper>
    <ButtonContainer>
      <Box margin="0 0.25rem">
        <ActionButton
          size={ActionButtonSizes.SMALL}
          variant={ActionButtonVariants.OUTLINE}
          data-testid="change-button"
          onClick={handleChangeRestaurant}
        >
          {changeText}
        </ActionButton>
      </Box>
      <Box margin="0 0.25rem">
        <ActionButton
          size={ActionButtonSizes.SMALL}
          data-testid="confirm-button"
          onClick={() => handleConfirmRestaurant(true)}
        >
          {confirmText}
        </ActionButton>
      </Box>
    </ButtonContainer>
  </StyledModal>
);
